// AbsenteeRoll.js
import React from 'react';

const AbsenteeRoll = () => {
    return <div>Absentee Roll Page</div>;
};

export default AbsenteeRoll;